// extracted by mini-css-extract-plugin
export default {"iwpCard":"iwpCardsStyles_iwpCard__W328w","iwpCardContainer":"iwpCardsStyles_iwpCardContainer__09rYD","iwpCardMarginRight4":"iwpCardsStyles_iwpCardMarginRight4__sauij"};